import React from "react";
import styles from "./pull-to-refresh-content.module.css";

interface PullToRefreshContentProps {
  children: React.ReactNode;
  pullDistance: number;
  isRefreshing: boolean;
}

export const PullToRefreshContent = ({
  children,
  pullDistance,
  isRefreshing,
}: PullToRefreshContentProps) => {
  const className = isRefreshing
    ? styles["pull-to-refresh-content-refreshing"]
    : styles["pull-to-refresh-content"];

  return (
    <div
      className={className}
      style={{
        transform:
          pullDistance > 0 ? `translateY(${pullDistance}px)` : undefined,
      }}
    >
      {children}
    </div>
  );
};
